import { Component } from '@angular/core';

@Component({
  selector: 'app-feature-filters',
  templateUrl: './feature-filters.component.html',
  styleUrls: ['./feature-filters.component.scss']
})
export class FeatureFiltersComponent {
  dropdownOptions = [
    {name: 'mock 01' },
    {name: 'mock 02' },
    {name: 'mock 03' },
  ];
}
